<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
<!--        <b-col-->
<!--          cols="12"-->
<!--          md="4"-->
<!--          class="mb-md-0 mb-2"-->
<!--        >-->
<!--          <label>Grupos</label>-->
<!--          <v-select-->
<!--            :value="grupoIdFIlter"-->
<!--            :options="grupoOptions"-->
<!--            class="w-100"-->
<!--            label="grupousuario"-->
<!--            :reduce="val => val"-->
<!--            @input="(val) => $emit('update:grupoFilter', val)"-->
<!--          />-->
<!--        </b-col>-->
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status</label>
          <v-select
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    roleFilter: {
      type: [String, null],
      default: null,
    },
    grupoFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: '',
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    grupoOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    grupoIdFIlter: {
      get() {
        return this.grupoFilter
      },
      set(val) {
        this.$emit('update:grupoFilter', val)
      },
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
